<script setup lang="ts" name="SailingScheduleCardContent">
const { isOpen } = defineProps<{
  isOpen: boolean;
}>();
</script>

<template>
  <div
    class="grid grid-cols-1 p-4 sm:gap-y-6 sm:pb-4 lg:grid-cols-[minmax(360px,_1fr)_minmax(0px,_2fr)] lg:pb-0"
    :class="isOpen ? 'lg:hidden' : 'grid'"
  >
    <div
      class="w-full shrink-0 grid-cols-2 items-center gap-6 xs:grid-cols-[minmax(0,_1fr)_96px_minmax(0,_1fr)]"
      :class="isOpen ? 'grid lg:hidden' : 'grid'"
    >
      <slot />
    </div>

    <div class="lg:pl-6">
      <slot name="append" />
    </div>
  </div>
</template>
